<template>
	<!--
		Listino di una fonte senza API: una o piu' versioni (valida dal mese), ognuna con fasce per importo
		dell'ordine, minimo e massimo per ordine e canone mensile.
	-->
	<div class="fre">
		<div v-for="(v, vi) in versions" :key="vi" class="fre-version">
			<div class="d-flex align-center flex-wrap" style="gap: 8px 12px">
				<v-text-field v-model="v.validFrom" type="month" label="Valida dal mese" dense outlined hide-details clearable class="fre-month" hint="Vuoto = da sempre" />
				<v-text-field v-model.number="v.minPerOrder" type="number" min="0" step="0.01" prefix="€" label="Minimo per ordine" dense outlined hide-details class="fre-num" />
				<v-text-field v-model.number="v.maxPerOrder" type="number" min="0" step="0.01" prefix="€" label="Massimo per ordine" dense outlined hide-details class="fre-num" />
				<v-text-field v-model.number="v.monthlyFee" type="number" min="0" step="0.01" prefix="€" label="Canone mensile" dense outlined hide-details class="fre-num" />
				<v-spacer />
				<v-btn text small color="error" @click="versions.splice(vi, 1)"><v-icon small left>mdi-delete-outline</v-icon>Togli versione</v-btn>
			</div>

			<v-simple-table dense class="mt-2 fre-tiers">
				<thead>
					<tr>
						<th>Importo ordine</th>
						<th>Percentuale</th>
						<th>Fisso per ordine</th>
						<th style="width: 44px"></th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(t, ti) in v.tiers" :key="ti">
						<td>
							<div class="d-flex align-center" style="gap: 6px">
								<span class="fre-muted text-no-wrap">{{ ti === 0 ? 'da 0 €' : `oltre ${formatEurCents(v.tiers[ti - 1].upTo || 0)}` }} fino a</span>
								<v-text-field v-model="t.upTo" type="number" min="0" step="0.01" prefix="€" dense hide-details single-line placeholder="senza limite" class="fre-num" />
							</div>
						</td>
						<td><v-text-field v-model.number="t.percent" type="number" min="0" max="100" step="0.01" suffix="%" dense hide-details single-line class="fre-num" /></td>
						<td><v-text-field v-model.number="t.fixed" type="number" min="0" step="0.01" prefix="€" dense hide-details single-line class="fre-num" /></td>
						<td>
							<v-btn v-if="v.tiers.length > 1" icon small title="Togli fascia" @click="v.tiers.splice(ti, 1)"><v-icon small>mdi-close</v-icon></v-btn>
						</td>
					</tr>
				</tbody>
			</v-simple-table>
			<v-btn text small color="primary" class="mt-1" @click="v.tiers.push({ upTo: '', percent: 0, fixed: 0 })"><v-icon small left>mdi-plus</v-icon>Aggiungi fascia</v-btn>
			<div class="fre-muted mt-1">Anteprima: {{ rateSummary(clean(v)) }}</div>
		</div>

		<div class="d-flex align-center mt-2">
			<v-btn text small color="primary" @click="aggiungiVersione"><v-icon small left>mdi-plus</v-icon>{{ versions.length ? 'Nuova versione del listino' : 'Aggiungi tariffa' }}</v-btn>
			<v-spacer />
			<v-btn text small @click="$emit('cancel')">Annulla</v-btn>
			<v-btn depressed small color="primary" :loading="saving" @click="$emit('save', versions.map(clean))"><v-icon small left>mdi-content-save-outline</v-icon>Salva tariffa</v-btn>
		</div>
	</div>
</template>

<script>
import { formatEurCents, rateSummary } from './format';

const copy = rate => ({
	validFrom: rate.validFrom || '',
	minPerOrder: rate.minPerOrder || 0,
	maxPerOrder: rate.maxPerOrder || 0,
	monthlyFee: rate.monthlyFee || 0,
	tiers: (rate.tiers && rate.tiers.length ? rate.tiers : [{ upTo: null, percent: rate.percent || 0, fixed: rate.fixed || 0 }]).map(t => ({
		upTo: t.upTo === null || t.upTo === undefined ? '' : t.upTo,
		percent: t.percent || 0,
		fixed: t.fixed || 0,
	})),
});

export default {
	name: 'FeeRateEditor',
	props: {
		rates: { type: Array, default: () => [] },
		month: { type: String, default: '' },
		saving: { type: Boolean, default: false },
	},
	data() {
		return { versions: this.rates.map(copy) };
	},
	methods: {
		formatEurCents,
		rateSummary,
		aggiungiVersione() {
			const last = this.versions[this.versions.length - 1];
			// la nuova versione parte dal mese che si sta guardando e copia le fasce della precedente
			this.versions.push(last ? { ...copy(last), validFrom: this.month } : { ...copy({}), validFrom: '' });
		},
		clean(v) {
			return {
				validFrom: v.validFrom || null,
				minPerOrder: +v.minPerOrder || 0,
				maxPerOrder: +v.maxPerOrder || 0,
				monthlyFee: +v.monthlyFee || 0,
				tiers: v.tiers.map(t => ({ upTo: t.upTo === '' || t.upTo === null ? null : +t.upTo, percent: +t.percent || 0, fixed: +t.fixed || 0 })),
			};
		},
	},
};
</script>

<style scoped>
.fre {
	padding: 4px 0 8px;
}
.fre-version {
	padding: 10px 0;
	border-bottom: 1px dashed #e1e7ef;
}
.fre-month {
	max-width: 200px;
}
.fre-num {
	max-width: 140px;
}
.fre-muted {
	font-size: 12px;
	color: #5f6b7a;
}
.fre-tiers {
	max-width: 640px;
	background: transparent !important;
}
</style>
